import { Box, Button, ButtonBase, Card, CardActions, CardContent, CardHeader, CardMedia, Divider, styled, Typography } from '@mui/material';
import React, { useEffect, useLayoutEffect, useState } from 'react';
import './styles.scss'; 
import moment from 'moment';
import placeHolderImage from "../../images/post_placeholder.jpeg";
import MoreHorizIcon from '@mui/icons-material/MoreHorizRounded';
import FavoriteRoundedIcon from '@mui/icons-material/FavoriteRounded';
import {HiAnnotation} from 'react-icons/hi';
import {FaRetweet} from 'react-icons/fa';
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';
import { deletePost, likePost, searchPosts } from '../../actions/posts';
import { useDispatch } from 'react-redux'; 
import {useNavigate} from 'react-router-dom';
import styles from './styles';
import theme from '../../muiTheme';
import { hexToRgb, truncate } from '../../utils/utils';
import useWindowDimensions from '../../hooks/useWindowDimensions';
import { useMemo } from 'react';
import UserAvatar from '../UserAvatar/UserAvatar';

const Post = ({ setSelectedPost, post, setCurrentId, animated }) => {

    const dispatch = useDispatch();
    const user = JSON.parse(localStorage.getItem('profile'));
    const navigate = useNavigate(); 
    const [likes, setLikes] = useState(post?.likes); 
    const [userLiked, setUserLiked] = useState(false); 
    const {windowHeight, windowWidth} = useWindowDimensions(); 
    const [gradientBackground, setGradientBackground] = useState('linear-gradient(63deg, rgba(238,174,202,1) 0%, rgba(148,187,233,1) 100%)');
    const [colorsFetched, setColorsFetched] = useState(false); 
    const [avColors, setAvColors] = useState({rgb: {r: 0, g: 0, b: 0}, rgb2: {r: 0, g: 0, b: 0}});
    const [userIsOwner, setUserIsOwner] = useState(false);
    
    let signedIn = (user?.result?.sub === post.creator || user?.result?._id === post.creator._id); 

    const fetchAVColors = (repeat = true) => {
        if(colorsFetched){
            return; 
        }

        //let imageEl = document.getElementById('post-view-mobile-image'); 
        let avColors = {rgb: {r: 0, g: 0, b: 0}, rgb2: {r: 0, g: 0, b: 0}}; 

        if(post && post.mediaAvColors.length > 0){

            avColors = JSON.parse(post.mediaAvColors[0]); //will need to adjust this for arrays of media

            console.log('post avColors: ', avColors);

            avColors.rgb = hexToRgb(avColors.avColor1);
            avColors.rgb2 = hexToRgb(avColors.avColor2);

            console.log('post avColors in rgb: ', avColors);
            setAvColors(avColors);
            setColorsFetched(avColors ? true : false);
        }


        let {r, g, b} = avColors.rgb; 
        let {r:r2, g:g2, b:b2} = avColors.rgb2;

        console.log('avColors: ', avColors);


        let gradBackground = `linear-gradient(45deg, rgb(${r}, ${g}, ${b}, 1) 0%, rgb(${r2}, ${g2}, ${b2}, 1) 100%)`; 

        console.log('grad background: ', gradBackground);
        setGradientBackground(gradBackground);
    }

    useLayoutEffect(()=>{

        fetchAVColors();
    }, []);

    useEffect(()=>{

        //findout if user liked post
        let liked = likes.find((like) => like === (user?.result?.sub || user?.result?._id)); 
        setUserLiked(liked); 

    }, [likes]);

    const Likes = () => {
      if (likes.length > 0) {
        return userLiked
          ? (
            likes.length > 2 ? `You and ${likes.length - 1} others` : `${likes.length} like${likes.length > 1 ? 's' : ''}` 
          ) : (
            `${likes.length}  ${likes.length === 1 ? 'Like' : 'Likes'}`
          );
      }
  
      return '0 Likes'
    };

    const openPost = (event) => {
        event.stopPropagation();

        let mobile = windowWidth <= 768; 

        console.log('window width: ', windowWidth);

        if(mobile){
            navigate(`/posts/${post._id}`);
        }else{ 
            setSelectedPost(post);
        }

    }

    const openTag = (tag) => {
        var query = {
            search:'none',
            tags: tag
        };

        dispatch(searchPosts(query));

        navigate(`/posts/search?searchQuery=none&tags=${tag}`); 
    }

    const editPost = (event, id) => {

        event.stopPropagation(); 

        setCurrentId(id)
    }

    const handleLikePost = async (event) => {
        if(user?.result){
           dispatch(likePost(post._id));
        }else{
            return
        }

        //Below code is for reflecting like in UI before API responds in case of lengthy response time

        //check if current user liked the post already
        if(likes.find((like) => like === (user?.result?.sub || user?.result?._id))){

            //remove like in UI
            setLikes(likes.filter((id) => id !== (user?.result.googleId || user?.result?._id)));
        } else {

            //add like in UI
            setLikes([...likes, (user?.result?.sub || user?.result?._id)]);

        }
    }

    const StyledCard = styled(Card)(({theme}) => ({
        
        bgcolor: "background.card", //you can reference theme as string if used by material component
        // maxWidth: '700px',
        width: '100%',
        transition: '0.5s',
        [theme.breakpoints.down('sm')]: {
            border: '0px solid transparent',
            borderRadius: '0px',
        }
    
    }));

    return (
        <StyledCard className={"card"+ (animated ? ' post-show[]' : '')} variant="outlined">

            <CardHeader
                sx={{
                    height:'50px'
                }}
                avatar={
                    <UserAvatar url={`/profile/${post.creator._id}`} sx={styles.mediaOverlay} imageURL={post.creator.profileImage || placeHolderImage} name={post.creator.name} createdAt={post.createdAt} alt={true} imageSx={{border: '2px solid white'}} verified={post.creator.verified}/>
                }
            
            />
                

                <div className="overlay2">

                    {signedIn && 

                        <Button
                            style={{color: 'white'}}
                            size="small"
                            onClick={(event)=> editPost(event, post._id) }
                        >
                            <MoreHorizIcon fontSize="default" />

                        </Button>
                    }
                    
                </div>
            
                

            <CardContent>

                <Typography
                    variant='body2'
                    color="textSecondary"
                    component="p"
                >

                    {truncate(post.message, 300)}
                </Typography>

                {
                    post.message.length > 300 &&

                    <Button 
                        variant='faint'    
                        sx={{padding: '3px 15px', marginTop: '15px'}}
                        onClick={openPost}>
                        Read more
                    </Button>
                }
                

            </CardContent>
            
         

            <CardActions
                className="cardActions"
                sx={{padding: '25px 10px'}}
            >

                <Box
                    sx={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between'}}
                >

                    <Box
                        color="secondary" 
                        sx={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center'}}
                        >
                        <FavoriteRoundedIcon onClick={handleLikePost} className="like-icon" style={{fontSize: '30px', cursor: signedIn? 'pointer': '', color: userLiked ? theme.palette.primary.main : theme.palette.secondary.main}} fontSize='small'/>
                        <Typography variant='body2' color='secondary'>
                            {post.likeCount}
                        </Typography>
                        

                    </Box>

                    <Box
                        color="secondary" 
                        sx={{display: 'flex', cursor: 'pointer', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', marginLeft: '20px'}}
                        >
                        <HiAnnotation onClick={openPost} className="like-icon" style={{fontSize: '30px', color: theme.palette.secondary.main}} fontSize='small'/>
                        <Typography variant='body2' color='secondary'>
                            {post.comments.length}
                        </Typography>
                        

                    </Box>

                    <Box
                        color="secondary" 
                        sx={{display: 'flex', cursor: 'pointer', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', marginLeft: '20px'}}
                        >
                        <FaRetweet onClick={openPost} className="like-icon" style={{fontSize: '30px', color: theme.palette.secondary.main}} fontSize='small'/>
                        <Typography variant='body2' color='secondary'>
                            {post.shareCount}
                        </Typography>
                    </Box>
                </Box>
                

                {/* {signedIn && 
                    <Button size="small" color="secondary" onClick={()=>{  dispatch(deletePost(post._id))}}>
                        <DeleteRoundedIcon fontSize='small'/>
                    </Button>
                } */}
                

            </CardActions>

            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '100%',
                    [theme.breakpoints.up('sm')]: {
                        display: 'none',
                    }
                }}
            >
                <Divider sx={{width: '80%', borderColor: 'rgb(228 228 228 / 50%)'}}/>
            </Box>
            

            
        </StyledCard>
    );
}

export default Post; 